import * as queries from 'src/graphql/queries'
import { graphqlApi } from 'src/redux/api/graphql/graphqlApi'
import type { ReduxCompany } from 'src/types/apiType'
import { API, graphqlOperation } from 'src/utils/amplify/legacy'
import { getErrorMessage } from 'src/utils/error'
import { makeErrorToast, msg } from 'src/utils/makeToast'
import { updateCompanyInfoWithDeltaSyncSuppress } from 'src/utils/miscellaneous'
import { getProperUpdateValues } from 'src/utils/updateApiUtil'

export const companyApi = graphqlApi.injectEndpoints({
	endpoints: (builder) => ({
		fetchCompanyById: builder.query({
			query: (id: string) => ({
				queryName: 'getCompany',
				data: {
					id,
				},
				isList: false,
			}),
			transformResponse: (response: ReduxCompany) =>
				response as ReduxCompany,
			providesTags: (result, error, id) => [{ type: 'Company', id }],
			keepUnusedDataFor: 300,
		}),
		updateCompanyById: builder.mutation({
			queryFn: async (updatedInput: Partial<ReduxCompany>) => {
				try {
					const {
						data: { getCompany },
					} = (await API.graphql(
						graphqlOperation(queries.getCompany, {
							id: updatedInput.id,
						})
					)) as {
						data: { getCompany: ReduxCompany }
					}
					const updatedCompany = getProperUpdateValues<ReduxCompany>({
						updatedInput,
						originalInput: getCompany,
					})
					// Check if updatedCompany has more than 2 keys in the object
					if (Object.keys(updatedCompany).length < 2) {
						return { data: null }
					}
					await updateCompanyInfoWithDeltaSyncSuppress(updatedCompany)
					return { data: null }
				} catch (error) {
					const errMsg = getErrorMessage(error)
					makeErrorToast(msg)
					return { error: errMsg }
				}
			},
			invalidatesTags: () => [{ type: 'Company' }],
		}),
	}),
	overrideExisting: false,
})

export const { useFetchCompanyByIdQuery, useUpdateCompanyByIdMutation } =
	companyApi
